"use client";

import { persistor, store, useAppDispatch } from "@/state/redux";
import { setLang } from "@/state/slices/settingSlice";
import { useLocale } from "next-intl";
import { useEffect } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

function LocaleSync({ children }: { children: React.ReactNode }) {
  const locale = useLocale();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (locale === "ar" || locale === "en") {
      dispatch(setLang({ lang: locale }));
    }
  }, [locale, dispatch]);

  return children;
}

const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <LocaleSync>{children}</LocaleSync>
      </PersistGate>
    </Provider>
  );
};

export default Providers;
